import { apiClient } from '@features/shared/api/client'
import type {
  MailingAddressFormat,
  SettingsResponse,
  UpdateSettingAssignmentsRequest,
} from './contracts'

export async function getSettings(): Promise<SettingsResponse> {
  const { data } = await apiClient.get<SettingsResponse>('/settings')
  return data
}

export async function updateSettings(
  payload: UpdateSettingAssignmentsRequest
): Promise<SettingsResponse> {
  const { data } = await apiClient.patch<SettingsResponse>('/settings', payload)
  return data
}

/** What a mailing address in this country is made of (Settings > Organization). */
export async function getMailingAddressFormat(countryCode: string): Promise<MailingAddressFormat> {
  const { data } = await apiClient.get<MailingAddressFormat>(
    `/settings/mailing-address-formats/${encodeURIComponent(countryCode)}`
  )
  return data
}
